import { FC } from "react";
import { Link } from "react-router-dom";

interface BlogCardProps {
  slug: string;
  label: string;
  description: string;
  img_src: string;
  tags?: string[];
  date?: string;
}

const BlogCard: FC<BlogCardProps> = ({
  slug,
  label,
  description,
  img_src,
  tags,
  date = "22.01.2026",
}) => {
  return (
    <Link
      to={`/tinklarastis/${slug}`}
      className="border-grey-300 flex w-full flex-col items-start gap-[30px] overflow-hidden rounded-[20px] border bg-white transition-shadow duration-300 hover:shadow-lg"
    >
      <div className="relative h-[240px] w-full shrink-0">
        <img
          alt={label}
          className="absolute inset-0 size-full max-w-none object-cover"
          src={img_src}
        />
      </div>
      <div className="flex w-full shrink-0 flex-col items-start gap-4 px-5 pb-[30px] text-start">
        <div className="flex w-full flex-col items-start gap-[14px]">
          <div className="flex w-full items-center justify-between">
            {tags && tags.length > 0 ? (
              <div className="bg-grey-100 flex items-center justify-center rounded-[28px] px-[14px] py-1">
                <p className="text-grey-500 text-center text-xs font-medium tracking-wider uppercase">
                  {tags[0]}
                </p>
              </div>
            ) : (
              <div />
            )}
            <p className="text-muted overflow-hidden text-sm font-light text-ellipsis">
              {date}
            </p>
          </div>
          <p className="text-dark w-full text-2xl leading-[1.2] font-medium whitespace-pre-wrap">
            {label}
          </p>
        </div>
        <p className="text-muted line-clamp-2 w-full overflow-hidden text-base leading-[1.5] font-light text-ellipsis">
          {description}
        </p>
      </div>
    </Link>
  );
};

export default BlogCard;
